import Util from '../forecast-app/shared/util/util';
import * as tracking from '../tracking';
import {graphql} from 'react-relay';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

const mutation = graphql`
	mutation deleteSubTaskMutation($input: SubTaskInput!) {
		deleteSubTask(input: $input) {
			deletedSubTaskId
			task {
				timeLeft
				latestUiUpdateAt
				latestUiUpdateBy {
					firstName
					lastName
				}
			}
		}
	}
`;

function getConfigs(input) {
	return [
		{
			type: 'RANGE_DELETE',
			parentID: input.taskId,
			connectionKeys: [
				{
					key: 'Task_subTasks',
				},
			],
			pathToConnection: ['task', 'subTasks'],
			deletedIDFieldName: 'deletedSubTaskId',
		},
	];
}

function getOptimisticResponse(input) {
	return {
		deleteSubTask: {
			deletedSubTaskId: input.id,
		},
	};
}

function commit(environment, input, onSuccess, onError) {
	tracking.trackEvent('Sub Task Deleted');
	return trackAndCommitMutation(environment, {
		mutation,
		variables: {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), id: input.id}},
		configs: getConfigs(input),
		optimisticResponse: getOptimisticResponse(input),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
